export default {
	POSITIVE: 3,
	NEGATIVE: 1,
	NEUTRAL: 2
}


// WEBPACK FOOTER //
// ./src/constants/typeMood.js